export default "__VITE_ASSET__CYf_C0Zs__"